// Chiavi stabili per liste editabili nell'admin (l'indice come key rompe focus/riordino)
export const uid = () => Math.random().toString(36).slice(2, 10);
export const withUids = (items) => (items || []).map((it) => (it._uid ? it : { ...it, _uid: uid() }));
